import {createDomainEvent, DomainEvent} from './domain-event'

export const OAuthEventTypes = {
  SignInProcess: 'oauth.sign_in.process',
  SignInDone: 'oauth.sign_in.done',
} as const

export type OAuthSignInProcessEvent = DomainEvent
export type OAuthSignInDoneEvent = DomainEvent

export const OAuthEvents = {
  OAuthSignInProcessStartedEvent(): OAuthSignInProcessEvent {
    return createDomainEvent(OAuthEventTypes.SignInProcess)
  },
  OAuthSignInProcessDoneEvent(): OAuthSignInDoneEvent {
    return createDomainEvent(OAuthEventTypes.SignInDone)
  },
}
